import { useSearchEngineStore } from '../../../stores/searchStore'
import {
  MdOutlineSell,
  MdKey,
  MdOutlineMapsHomeWork
} from 'react-icons/md'

import { ButtonLikeCheckbox } from './ButtonLikeCheckbox'
import { OperationTypes } from '../../../../../types-library/src'

interface Props {
  isActiveButtonClassName?: string
}

export const OperationType = ({ isActiveButtonClassName }: Props) => {
  const { operationType, setOperationType } = useSearchEngineStore((state) => state)
  
  const propertyTypeOptions: {
    title: string
    icon: React.ReactNode
    code: OperationTypes
  }[] = [
    {
      title: 'Venta',
      code: OperationTypes.SALE,
      icon: <MdOutlineSell className="w-4 h-4" />
    },
    {
      title: 'Renta',
      code: OperationTypes.LEASE,
      icon: <MdKey className="w-4 h-4" />
    },
    {
      title: 'Preventa',
      code: OperationTypes.PRESALE,
      icon: <MdOutlineMapsHomeWork className="w-4 h-4" />
    }
  ]

  return (
    <div className="flex flex-col gap-y-3">
      <span className="text-normal font-semibold text-[#222]">
        Tipo de operación
      </span>
      <div className="flex items-center gap-3">
        {propertyTypeOptions.map(({ code, title, icon}) =>  (
          <ButtonLikeCheckbox
            code={code}
            title={title}
            icon={icon}
            isSelected={code === operationType}
            onClick={(code: string) => setOperationType(code)}
            isActiveButtonClassName={isActiveButtonClassName}
          />
        ))}
      </div>
    </div>
  )
}

